import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useMerchantBannerSection} from '../useGetProductBulkSection';
import {MerchantBannerView} from './MerchantBannerView';

export const MerchantBanner: React.FC<
  React.PropsWithChildren & {className?: string}
> = props => {
  return (
    <DataFetcher
      request={useMerchantBannerSection()}
      Error={() => null}
      Loading={undefined}
      View={MerchantBannerView}
      viewProps={props}
    />
  );
};
